import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DashboardSummaryComponent } from './dashboard-summary.component';

const routes: Routes = [
  { path: '', component: DashboardSummaryComponent, data: { title: 'Dashboard Summary' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardSummaryRoutingModule {}

@NgModule({
  imports: [
    DashboardSummaryRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [DashboardSummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardSummaryModule {}
